let dialog_data = {
  dialog_load: {
    show: true,
    message: "กำลังดึงข้อมูล"
  },
  dialog_alert: {
    show: false,
    type: "success",
    title: "",
    message: ""
  }
};

let dialog_methods = {
  showDialogAlert(is_show, type = "success", title = "", message = "") {
    this.dialog_alert = {
      show: is_show,
      type: type,
      title: title,
      message: message
    };
  },
  showDialogLoad(is_show, message = "กำลังดึงข้อมูล") {
    this.dialog_load = {
      show: is_show,
      message: message
    };
  }
};

export { dialog_methods, dialog_data };
